import { createListenerMiddleware } from '@reduxjs/toolkit';

import { chatEntity } from '~entities/chats/chatEntity';
import { dialogsApi } from '~services/api/dialogs';
import { messageReceived } from '~store/utils/message-received';

export const typingIndicatorDataProcessing = createListenerMiddleware();

typingIndicatorDataProcessing.startListening({
	matcher: dialogsApi.endpoints.sendMessage.matchFulfilled,
	effect: (action, listenerApi) => {
		const recipientId = action.meta.arg.originalArgs.recipientId;

		chatEntity.update(listenerApi.getState, listenerApi.dispatch, (draft) => {
			if (draft.botId === recipientId) {
				draft.isTyping = true;
			}
		});
	},
});

typingIndicatorDataProcessing.startListening({
	actionCreator: messageReceived,
	effect: (action, listenerApi) => {
		const recipientId = action.payload;

		chatEntity.update(listenerApi.getState, listenerApi.dispatch, (draft) => {
			if (draft.botId === recipientId) {
				draft.isTyping = false;
			}
		});
	},
});
